var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19502 9.20552C11.4954 9.20552 13.3603 7.36865 13.3603 5.10276C13.3603 2.83687 11.4954 1 9.19502 1C6.89463 1 5.02979 2.83687 5.02979 5.10276C5.02979 7.36865 6.89463 9.20552 9.19502 9.20552Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41156 17.411C1.54281 17.411 0.858522 16.6373 1.02513 15.7992C1.78678 12.0422 5.15467 9.20544 9.19495 9.20544C13.2352 9.20544 16.6031 12.0363 17.3648 15.7992C17.5373 16.6373 16.8471 17.411 15.9783 17.411H2.41156Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileBlue);
export default __webpack_public_path__ + "static/media/UserProfileBlue.876d747d0b172a1bad870e71e2cd7d60.svg";
export { ForwardRef as ReactComponent };